<template>
  <div v-resize="onResize" class="h-100">
    <v-data-table :headers="headers" :items="data" :loading="loading" :height="height" class="elevation-1 content" must-sort fixed-header disable-pagination dense hide-default-footer>
      <template v-slot:item.starttimestamp="{ item }">
        {{ item.starttimestamp | format('yyyy-MM-dd HH:mm:ss') }}
      </template>
      <template v-slot:item.account="{ item }">
        {{ item.account }} /
        {{ item.terminalid }}
      </template>
      <template v-slot:item.respti="{ item }">
        {{ convertTimeUnit(item.respti) }}
      </template>
      <template v-slot:item.detail="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="openSsrViewer(item)" x-small>...</v-btn>
          </template>
          <span>SSR Viewer</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { addSeconds, subSeconds } from 'date-fns';
import { api } from '@/api/common/instances';
import bus from '@/utils/bus';

export default {
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: [],
      loading: false,
      height: 0,
    };
  },
  computed: {
    headers() {
      return [
        { text: 'Start Time', value: 'starttimestamp', width: '10%' },
        { text: 'User / IP', value: 'account', width: '13%' },
        { text: 'Instance', value: 'instId', width: '10%' },
        { text: 'T-Code', value: 'tcode', width: '10%' },
        { text: 'Report of RM', value: 'report', width: '10%' },
        { text: 'Dyn', value: 'dynpronr', width: '10%' },
        { text: 'Reference Program', value: 'cuaProg', width: '10%' },
        { text: 'Internal Command', value: 'cuaFunc', width: '13%' },
        { text: 'Response Time (ms)', value: 'respti', width: '10%', align: 'end' },
        { text: '', value: 'detail', width: '3%', sortable: false },
      ];
    },
  },
  watch: {
    params: {
      deep: true,
      handler() {
        this.fetchData(this.params);
      },
    },
  },
  created() {
    this.fetchData(this.params);
    bus.$on('click:grid', timestamp => {
      this.fetchData({ datetime: timestamp, sid: this.params.sid, iid: this.params.iid });
    });
  },
  methods: {
    async fetchData({ datetime, sid, iid }) {
      this.loading = true;
      ({ data: this.data } = await api.get('/analysis/context-ssr', {
        params: {
          srchBgnYmdhms: subSeconds(datetime, 15).getTime(),
          srchEndYmdhms: addSeconds(datetime, 15).getTime(),
          sstmId: sid,
          instId: iid,
        },
      }));
      this.loading = false;
    },
    convertTimeUnit(time) {
      const millis = time / 1000;
      return millis > 1 ? millis.toFixed(0) : 1;
    },
    openSsrViewer(item) {
      const params = {
        dt: item.bgnYmdhms,
        sid: item.sstmId,
        iid: item.instId,
        seq: item.seq,
        acc: item.account,
        tid: item.terminalid,
      };
      window.open(`/views/analysis/ssr-viewer?${new URLSearchParams(params).toString()}`, '_blank', 'width=700, height=930');
    },
    onResize() {
      const height = window.innerHeight - 190;
      this.height = height - height * 0.6;
    },
  },
};
</script>

<style lang="scss" scoped></style>
